var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.431,
    height: 19.153,
    viewBox: "0 0 5.6702 5.0675",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.51156 -291.26)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0223 291.39h4.6702l0.15797 0.067 0.1083 0.10193 0.0737 0.12627 0.017 0.13437v3.1554l-0.0267 0.12626-0.0817 0.10251-0.10271 0.0843-0.12326 0.0592h-3.4041l-0.01 0.0752-0.0194 0.0808-0.0194 0.0517-0.0468 0.10336s-0.0339 0.0533-0.0371 0.0598c-3e-3 7e-3 -0.0328 0.0499-0.0328 0.0499l-0.0362 0.0424-0.0413 0.0465-0.0393 0.0413-0.0351 0.0341-0.0393 0.031-0.0444 0.0372-0.0434 0.0351-0.0506 0.0331-0.0382 0.0238-0.0496 0.0279-0.0455 0.0217-0.0424 0.0134-0.062 0.0248-0.0486 9e-3 -0.0548 4e-3 0.10749-0.0279 0.0341-0.0217 0.0196-0.0248 0.0238-0.0279 0.0186-0.0289 0.0114-0.031 0.0104-0.0393 4e-3 -0.0424v-0.60565h-0.74724l-0.12388-0.0628-0.0907-0.0831-0.0673-0.10573-0.0313-0.10597v-3.2358l0.0395-0.11486 0.0989-0.11915 0.10631-0.0729z",
    fill: "#fff",
    strokeWidth: 0.26458
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.13229
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.0481 292.42h4.6054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.0481 293.37h4.6054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.0481 294.31h3.762"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.e95601bf0040200890175483b295d47b.svg";
export { ForwardRef as ReactComponent };